import * as React from 'react';

export type LinkedInIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Defaults to your original SVG fill (#222222) */
  color?: string;
};

function LinkedInIcon({
  size = 19,
  title = 'LinkedIn',
  className,
  style,
  color = '#222222',
  ...spanProps
}: LinkedInIconProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        lineHeight: 0,
        ...style,
      }}
      {...spanProps}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 19 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
        focusable='false'
      >
        <path
          d='M2.52086 0.3125C1.3006 0.3125 0.3125 1.30386 0.3125 2.52331C0.3125 3.74438 1.3006 4.73574 2.52086 4.73574C3.73868 4.73574 4.7276 3.74438 4.7276 2.52331C4.7276 1.30386 3.73868 0.3125 2.52086 0.3125Z'
          fill={color}
        />
        <path
          d='M14.1194 6.10854C12.267 6.10854 11.0247 7.12597 10.5164 8.09045H10.4659V6.41402H6.81248V18.6875H10.6183V12.6155C10.6183 11.0148 10.9213 9.46386 12.9032 9.46386C14.8558 9.46386 14.8827 11.2951 14.8827 12.719V18.6875H18.6868V11.9549C18.6868 8.65008 17.9749 6.10854 14.1194 6.10854Z'
          fill={color}
        />
        <path
          d='M4.42493 18.6873H0.616707V6.41377H4.42493V18.6873Z'
          fill={color}
        />
      </svg>
    </span>
  );
}

export default LinkedInIcon;
